import {Form} from "react-bootstrap";
import DatePicker from "react-datepicker";
import styled from "styled-components";

import {getTheme} from "../shared/themeUtils";

const Contain = styled.div`
  #datePicker.red-border {
    border-color:red;
  }
    position: relative;
    label.form-label {
      position: absolute;
      top: 11px;
      z-index: 2;
      left: 15px;
      font-size: ${getTheme("fontSizes.xSmall")};
      opacity: .6;
    }
    input {
      padding: 29px ${getTheme("space.2")} ${getTheme("space.1")}!important;
      border-radius: ${getTheme("borderRadius")};
    }
  
  .hidden-field {
    display: none;
  }
  .invalid-feedback {
    text-align: left;
  }

    .error-msg {
        font-size: ${getTheme("fontSizes.small")};
        color: red;
        text-align: left;
        margin-top: ${getTheme("space.0")};
    }
  
  // Customize react-date-select header
  .react-datepicker__header__dropdown {
    margin-top: ${getTheme("space.0")};
    
    select {
      border: 1px solid ${getTheme("colors.border")};
      padding: 0 ${getTheme("space.0")};
    }
  }
`

type DateSelectorPropsType = {
    label: string,
    selected: Date,
    maxDate?: Date,
    minDate?: Date,
    setSelected: any,
    errorMsg?: [],
    required?: boolean
}

const DateSelector = (props: DateSelectorPropsType) => {
    const {label, selected, maxDate, minDate, setSelected, required, errorMsg} = props
  return (
        <Contain>
            <Form.Label>{label}</Form.Label>
            <DatePicker id="datePicker"
                        selected={selected}
                        maxDate={maxDate}
                        minDate={minDate}
                        dateFormat={["dd-MM-yyyy", "dd.MM.yyyy", "dd/MM/yyyy"]}
                        className={errorMsg ? "red-border" : ""}
                        showMonthDropdown
                        showYearDropdown
                        required={required}
                        dropdownMode="select"
                        onChange={(date) => setSelected(date as Date)}
            />

          {/*<Form.Control isInvalid={!!errorMsg} className={"hidden-field"} />*/}
          {errorMsg && errorMsg.map((msg: string) => {
            return (
              <div key={msg} className={"error-msg"}>{msg}</div>
            )
          }) }
        </Contain>
    )
}

export default DateSelector;